window.addEventListener("load", () => {
  const servingTag = document.getElementById("price-per-serving");
  if (!servingTag) return;

  const servingInfo = servingTag.dataset.servings || "";
  const servingsMatch = servingInfo.match(/\d+/);
  const servings = servingsMatch ? parseInt(servingsMatch[0], 10) : null;
  if (!servings) return;

  const parsePrice = (el) => {
    if (!el) return null;
    return parseFloat(el.textContent.replace(/[^0-9.]/g, ""));
  };

  const getRechargePrice = (isSubscription) => {
    const widget = document.querySelector("recharge-subscription-widget");
    const root = widget?.shadowRoot;
    if (!root) return null;

    if (isSubscription) {
      const el = root.querySelector(
        ".rc-purchase-option__subscription .rc-price:not(.strike-through)"
      );
      return parsePrice(el);
    } else {
      const el = root.querySelector(".rc-selection__onetime .rc-price");
      return parsePrice(el);
    }
  };

  const getShopifyPrice = () => {
    const cents =
      window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.price || 0;
    return cents / 100;
  };

  const updateServingPrice = (isSubscription) => {
    let price = getRechargePrice(isSubscription);
    if (!price) {
      price = getShopifyPrice();
      if (isSubscription) {
        price = price * 0.9;
      }
    }

    const perServing = price / servings;
    servingTag.textContent = `$${perServing.toFixed(2)} PER SERVING`;
  };

  // initial run
  const widget = document.querySelector("recharge-subscription-widget");
  const root = widget?.shadowRoot;
  const selectedOption = root?.querySelector(
    '.rc-purchase-option__input:checked'
  );
  updateServingPrice(selectedOption?.value === "subscription");

  // listen for changes
  setupRechargeListeners(updateServingPrice);
  
  function setupRechargeListeners(updateServingPrice) {
    if (!root) return;
    root.querySelectorAll(".rc-purchase-option__input").forEach((input) => {
      input.addEventListener("change", (e) => {
        updateServingPrice(e.target.value === "subscription");
      });
    });
  }
});
